import React from "react";
import { Navigate } from "react-router-dom";
import { AuthModel } from "../../services/models";
import PublicLayout from "../../layouts/PublicLayout";

export default function PublicLayoutRoute() {
  const token = AuthModel.getToken();
  const user = AuthModel.getUser();

  // If user is already logged in, redirect to appropriate dashboard
  if (token && user) {
    return user.role === "admin" ? (
      <Navigate to="/" replace />
    ) : (
      <Navigate to="/all-orders" replace />
    );
  }

  return <PublicLayout />;
}

